import * as React from 'react';
import { SVGProps } from 'react';

const IconFileUnknownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2a3 3 0 0 0-3 3v.543H4V5a4 4 0 0 1 4-4c2.213 0 4 1.816 4 4.021 0 2.215-1.783 4.041-4 4.065V11H7V8.086h.957C9.634 8.086 11 6.706 11 5.02 11 3.361 9.653 2 8 2ZM7 15v-2h1v2H7Z"
    />
  </svg>
);
export default IconFileUnknownSizeS;
